module.exports = __webpack_public_path__ + "static/media/blockchain.b89288a1.png";